<template lang="pug">
    .comments.container
        h3.has-text-centered.is-size-4 Kommentare
        CommentInput(:pageId="pageId")
        Comment.comment.column.is-offset-3.is-half(
            v-if="comments && comments.length"
            v-for="comment in comments" :key="comment.id"
            :comment="comment"
            :stars="stars"
        )
</template>
<script>

import moment from 'moment'
import Comment from './Comment'
import CommentInput from './CommentInput'

export default {
    name: 'Comments',
    components: {
        Comment,
        CommentInput,
    },
    data() {
        return {
            rating: null,
            stars: 5,
        }
    },
    props: {
        comments: {
            required: true,
            type: Array
        },
        pageId: {
            required: true,
            type: Number
        }
    },
}
</script>
<style lang="sass" scoped>
    h3
        margin-bottom: 30px
    .comments
        & > .comment
            margin-top: 40px
            &:first-of-type
                border-top: 1px solid #ccc
                padding-top: 50px
            &:last-of-type
                margin-bottom: 40px
</style>
